import React from "react";
import { Field, Switch, Input, Checkbox, Text, Divider } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import "../../CSS/IaAgent.css";

const CAPTURE_FIELDS = ["caller_name", "phone_number", "message"];

function SkillCard({ title, description, children }) {
  return (
    <div className="ia-agent-card">
      <Text weight="semibold" size={400} style={{ display: "block" }}>
        {title}
      </Text>
      {description && (
        <Text size={200} style={{ color: "#666", display: "block", marginBottom: 10 }}>
          {description}
        </Text>
      )}
      <div style={{ marginTop: 8 }}>{children}</div>
    </div>
  );
}

export default function SkillsTab({ agentData, updateField }) {
  const { t } = useTranslation();
  const skills = agentData.skills || {};

  const toggleCaptureField = (field, checked) => {
    const current = Array.isArray(skills.leaveMessage?.captureInfo) ? skills.leaveMessage.captureInfo : [];
    const next = checked ? Array.from(new Set([...current, field])) : current.filter((f) => f !== field);
    updateField("skills.leaveMessage.captureInfo", next);
  };

  return (
    <div className="ia-agent-tab">
      {/* userSearch */}
      <SkillCard title={t("SKILL_USER_SEARCH")} description={t("SKILL_USER_SEARCH_DESC")}>
        <Switch
          label={t("ENABLED")}
          checked={!!skills.userSearch?.enabled}
          onChange={(_, d) => updateField("skills.userSearch.enabled", d.checked)}
        />
      </SkillCard>

      {/* userPresence */}
      <SkillCard title={t("SKILL_USER_PRESENCE")} description={t("SKILL_USER_PRESENCE_DESC")}>
        <Switch
          label={t("ENABLED")}
          checked={!!skills.userPresence?.enabled}
          onChange={(_, d) => updateField("skills.userPresence.enabled", d.checked)}
        />
        <div style={{ marginTop: 8 }}>
          <Checkbox
            label={t("ANNOUNCE_STATUS")}
            checked={!!skills.userPresence?.announceStatus}
            onChange={(_, d) => updateField("skills.userPresence.announceStatus", !!d.checked)}
            disabled={!skills.userPresence?.enabled}
          />
        </div>
      </SkillCard>

      {/* transferToUser */}
      <SkillCard title={t("SKILL_TRANSFER_TO_USER")} description={t("SKILL_TRANSFER_TO_USER_DESC")}>
        <Switch
          label={t("ENABLED")}
          checked={!!skills.transferToUser?.enabled}
          onChange={(_, d) => updateField("skills.transferToUser.enabled", d.checked)}
        />
        <div style={{ marginTop: 8 }}>
          <Checkbox
            label={t("REQUIRE_CONFIRMATION")}
            checked={!!skills.transferToUser?.requireConfirmation}
            onChange={(_, d) => updateField("skills.transferToUser.requireConfirmation", !!d.checked)}
            disabled={!skills.transferToUser?.enabled}
          />
        </div>
      </SkillCard>

      {/* transferToPhone */}
      <SkillCard title={t("SKILL_TRANSFER_TO_PHONE")} description={t("SKILL_TRANSFER_TO_PHONE_DESC")}>
        <Switch
          label={t("ENABLED")}
          checked={!!skills.transferToPhone?.enabled}
          onChange={(_, d) => updateField("skills.transferToPhone.enabled", d.checked)}
        />
        <div style={{ marginTop: 8 }}>
          <Checkbox
            label={t("REQUIRE_CONFIRMATION")}
            checked={!!skills.transferToPhone?.requireConfirmation}
            onChange={(_, d) => updateField("skills.transferToPhone.requireConfirmation", !!d.checked)}
            disabled={!skills.transferToPhone?.enabled}
          />
        </div>
      </SkillCard>

      {/* hangupCall — always enabled */}
      <SkillCard title={t("SKILL_HANGUP")} description={t("SKILL_HANGUP_DESC")}>
        <Switch label={t("ENABLED")} checked={true} disabled />
        <Field label={t("FAREWELL_MESSAGE")} className="field-style" style={{ marginTop: 12 }}>
          <Input
            value={skills.hangupCall?.farewellMessage || ""}
            onChange={(_, d) => updateField("skills.hangupCall.farewellMessage", d.value)}
            placeholder="Goodbye and have a great day!"
          />
        </Field>
      </SkillCard>

      {/* leaveMessage */}
      <SkillCard title={t("SKILL_LEAVE_MESSAGE")} description={t("SKILL_LEAVE_MESSAGE_DESC")}>
        <Switch
          label={t("ENABLED")}
          checked={!!skills.leaveMessage?.enabled}
          onChange={(_, d) => updateField("skills.leaveMessage.enabled", d.checked)}
        />
        <Field label={t("CAPTURE_INFO")} className="field-style" style={{ marginTop: 12 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {CAPTURE_FIELDS.map((field) => (
              <Checkbox
                key={field}
                label={t(`CAPTURE_${field.toUpperCase()}`)}
                checked={(skills.leaveMessage?.captureInfo || []).includes(field)}
                onChange={(_, d) => toggleCaptureField(field, !!d.checked)}
                disabled={!skills.leaveMessage?.enabled}
              />
            ))}
          </div>
        </Field>
      </SkillCard>

      <Divider style={{ margin: "16px 0" }} />
      <Text className="ia-agent-hint">{t("SKILLS_TAB_HINT")}</Text>
    </div>
  );
}
